import { AUDIT_MODELS_API_URL } from 'constants/ApiConstants';

import * as types from '../actionTypes';

export const duplicate = (auditModelId, dealerId) => ({
  type: types.DUPLICATE,
  payload: {
    request: {
      method: 'POST',
      url: `${AUDIT_MODELS_API_URL}/${auditModelId}/clone`,
      data: {
        dealerId,
      },
    },
  },
});

export const duplicateSuccess = auditModel => ({
  type: types.DUPLICATE_SUCCESS,
  payload: auditModel,
});

export const duplicateFailure = error => ({
  type: types.DUPLICATE_FAILURE,
  payload: error,
  error: true,
});
